import React from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { Module } from "Components/Module";

export interface ModuleFooterProps {
   className?: string
}

const ModuleFooter: React.FC<ModuleFooterProps> = ({ className }) => {
   return (
      <Module tag="footer" className={classNames("portal-footer", className)}>
         <a className="portal-footer-logo" href="/" aria-label="LiquidSpace Home page">
            <Icons.LiquidSpacePoweredByLogo preserveAspectRatio="xMinYMid slice" />            
         </a>
         <div className="portal-footer-links">
            <div className="portal-footer-copyright">© LiquidSpace 2024</div>
            <a href="/terms/terms-of-use" target="_blank" className="portal-footer-link">Terms of Use</a>
            <a href="/terms/privacy-policy" target="_blank" className="portal-footer-link">Privacy Policy</a>
         </div>
      </Module>
      )
}

export default ModuleFooter;